import * as React from "react";
const SvgDotIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 9, viewBox: "0 0 8 9", fill: "#E29D70", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4.3042, r: 3 }));
export default SvgDotIcon;
